import React from 'react';
import styled from 'styled-components';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import HeaderIcons from '@components/shared/HeaderIcons';
import Colors from '../Colors';

const ShoppingUsps: React.FC = () => {
  const { productHeaderData } = useShoppingContext();
  const { verticalIcons, icons } = productHeaderData;
  const hasUspIcons = icons?.length && icons[0]?.icon_text?.text;

  if (!hasUspIcons) {
    return null;
  }

  return (
    <Container>
      <UspsWrap>
        <HeaderIcons icons={icons} iconSize={'24px'} isVerticalDirection={verticalIcons} />
      </UspsWrap>
    </Container>
  );
};

export default ShoppingUsps;

const Container = styled.div`
  width: 100%;
`;

const UspsWrap = styled.div`
  padding: 24px;
  background: ${Colors.paleGold25};
  border-radius: 4px;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }

  @media (max-width: 500px) {
    margin-left: -16px;
    margin-right: -16px;
    border-radius: 0;
  }

  .icon-rows-wrap {
    padding: 0;
    gap: 10px;

    @media (max-width: 1024px) {
      padding: 0;
    }

    @media (max-width: 768px) {
      gap: 8px;
    }
  }

  .icon-wrap {
    flex: 1;
    padding: 0;
    gap: 8px;

    @media (max-width: 1024px) {
      gap: 0;
      max-width: 115px;
    }
  }

  .icon-text {
    text-transform: none;
    letter-spacing: normal;
    font-family: BrownStd;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
  }
`;
